export class IdName {
  id!: string;
  name!: string;
}
